import React, { useCallback } from "react";
import { ActionButton } from "fe-common/ui/buttons/actionButton";

import { ACTION, CATEGORY, evt } from "fe-common/analytics/analytics";
import { AgentRoute } from "../../util/agentRoutes";
import { useRouteHelper } from "../../useRouteHelper";
import PatientSummaryIcon from "../../../../assets/patientSummaryIcon.svg";

//region [[ Styles ]]

//endregion [[ Styles ]]

//region [[ Props ]]

export interface PatientSummaryButtonProps {
  className?: string;
  onlyIcon?: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const PatientSummaryButton = ({
  ...props
}: PatientSummaryButtonProps) => {
  const { navigateTo } = useRouteHelper();
  const handleOnClick = useCallback(() => {
    evt({
      category: CATEGORY.AGENT,
      action: ACTION.EXPORT_DATA_CLICKED_MOBILE,
    });
    navigateTo({ route: AgentRoute.Export });
  }, [navigateTo]);

  return (
    <ActionButton
      className={props.className}
      label={"Patient Summary"}
      onClick={handleOnClick}
      icon={<img src={PatientSummaryIcon} alt={"Patient Summary Icon"} />}
      iconOnly={props.onlyIcon}
    />
  );
};
